import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  isLoading: true,
  isSuccess: false,
  isError: false,
  message: "",
  response: {},
  // productId: "",
};

export const uploadProductImages = createAsyncThunk(
  "products/upload_product_images",
  async (productImageDetails, thunkAPI) => {
    console.log("product upload Images", productImageDetails);
    try {
      const formData = new FormData();
      if (productImageDetails.productImages.length === 0) {
        return formData.append("product_image", null);
      }
      for (let i = 0; i < productImageDetails.productImages.length; i++) {
        formData.append("product_image", productImageDetails.productImages[i]);
      }
      formData.append("product_id", productImageDetails.productId);

      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/product/product_image_Upload`,
        formData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const addProductMultiImagesSlice = createSlice({
  name: "addProductMultiImages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(uploadProductImages.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(uploadProductImages.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.isError = false;
      state.message = action.payload.message;
      state.response = action.payload;
      // state.productId = action.payload?.result?.affectedRows?.id;
    });
    builder.addCase(uploadProductImages.rejected, (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = true;
      state.message = action.payload.message;
      state.response = action.payload;
      console.error(action.error);
    });
  },
});
export const { viewProduct, openDeleteModal, closeModal, editProduct } =
  addProductMultiImagesSlice.actions;
export default addProductMultiImagesSlice.reducer;
